<template>
  <div class="badge text-blue-f bg-blue" v-if="hasCount()" @click.stop="onClick">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-notes">
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M5 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -14" />
      <path d="M9 7l6 0" />
      <path d="M9 11l6 0" />
      <path d="M9 15l4 0" />
    </svg>
    {{ count }}
  </div>
</template>

<script>
import {defineComponent, onMounted, ref, watch} from "vue"
import { useRouter } from 'vue-router'
import Api from "./services/Api"
import Helper from "@/services/Helper"

export default defineComponent({
  name: "CountPostModeration",
  components: {},
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  setup(props, {emit}) {
    const router = useRouter()
    let payload = geyPayload()
    let count = ref(0)

    onMounted(() => {
      let typeIds = []
      let typeVisible = null

      if (isPrivate()) {
        typeIds = [5]
        typeVisible = 1
      }

      if (isPublic()) {
        typeIds = [6, 7]
        typeVisible = 2
      }

      getCount(typeIds, typeVisible).then((resp) => {
        count.value = resp
      })
    })

    function isPrivate() {
      return payload.typeVisible === 1
    }

    function isPublic() {
      return payload.typeVisible === 2
    }

    function isSiteChannel(channelId) {
      return Helper.inArray([channelId], [1])
    }

    function onClick() {
      if (isSiteChannel(payload.channelId)) {
        if (isPrivate()) {
          router.push({name: "NotesNotModerated"})
        }

        if (isPublic()) {
          router.push({name: "PostsNotModerated"})
        }
      }
    }

    async function getCount(typeIds, typeVisible) {
      if (isSiteChannel(payload.channelId)) {
        return await Api.count(typeIds, typeVisible)
      }
    }

    function geyPayload() {
      let channelId = null
      let typeVisible = null

      if (Helper.inArray([props.payload.type_visible], [1, 2])) {
        typeVisible = props.payload.type_visible
      }

      if (typeof props.payload.channel_id === "number") {
        channelId = props.payload.channel_id
      }

      return {
        channelId,
        typeVisible,
      }
    }

    function hasCount() {
      return count.value > 0
    }

    watch(count, (val) => {
      emit('update:visible', val > 0)
    })

    return {
      onClick,
      count,
      hasCount,
      isPrivate,
      isPublic,
    }
  }
})
</script>

<style scoped>
  #count-post-moderation .alert {
    font-size: 16px
  }
  #count-post-moderation .alert:hover {
    cursor: pointer;
  }
</style>
